/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Application from './application/container/ApplicationContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';

function NOVListingContainer({ match }) {
  return (
    <div className="module-inner">
      <div className="module-inner-title">Notice of Violations</div>
      <div className="generic-module-nav mb-3">
        <NavLink
          exact
          className="nav-link"
          activeClassName="active"
          to="/notice-of-violations"
        >
          Dashboard
        </NavLink>
        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/notice-of-violations/application"
        >
          Applications
        </NavLink>
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        <Route path={`${match.path}/application`} component={Application} />
      </Switch>
    </div>
  );
}

NOVListingContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(NOVListingContainer);
